import React from "react";
import PropTypes from "prop-types";
import Limiter from "../../../../components/atoms/Limiter";
import ExpandLink from "../../../../components/atoms/Limiter/ExpandLink";
import TableSorter from "../../../../components/atoms/TableSorter";
import JaxCkbTable from "./JaxCkbTable";
import { sortStr } from "../../../../common/helpers/helpers";

const sortByAmpTier = (a, b) => sortStr(a.amp_tier, b.amp_tier);
const renderTable = (props) => {
  return <JaxCkbTable {...props} />;
};

const renderLimiter = (props) => {
  return (
    <React.Fragment>
      <Limiter
        {...props}
        ExpandLink={(p) => (
          <div className="tw-p-2">
            <ExpandLink {...p} />
          </div>
        )}
        items={props.sortedItems}
        limit={5}
        shouldAutoCollapse={false}
        renderContent={renderTable}
      />
    </React.Fragment>
  );
};

function JaxCkbContent(props) {
  const { items } = props;

  return (
    <div className="tw-p-2 tw-inline-block" id="jax-ckb-table-evidence">
      <TableSorter
        {...props}
        items={items}
        defaultSortedField="amp_tier"
        defaultComparator={sortByAmpTier}
        renderContent={renderLimiter}
      />
    </div>
  );
}

JaxCkbContent.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      amp_tier: PropTypes.string,
      approval_status: PropTypes.string,
      cap_asco_evidence_level: PropTypes.string,
      efficacy_evidence: PropTypes.string,
      evidence_type: PropTypes.string,
      indication: PropTypes.string,
      normalized_cancer: PropTypes.string,
      normalized_drug: PropTypes.string,
      pub_med_references: PropTypes.arrayOf(PropTypes.number),
      response_type: PropTypes.string,
      therapy: PropTypes.string,
      therapy_id: PropTypes.number,
    })
  ),
  evidenceType: PropTypes.string.isRequired,
};

JaxCkbContent.defaultProps = {
  items: [],
};

export default JaxCkbContent;
